import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["metric", "display", "days", "months", "limit"]

  connect() {
    this.refresh()
  }

  refresh() {
    const metric = this.metricTarget.value
    const displayMap = {
      task_status_breakdown: ["donut", "bar"],
      tasks_by_project: ["bar", "donut"],
      workload_by_assignee: ["bar", "donut"],
      completed_tasks_trend: ["line", "bar"],
      sales_by_month: ["bar", "line"]
    }
    const labels = { bar: "Bars", donut: "Donut", line: "Line" }
    const allowed = displayMap[metric] || ["bar"]
    const selected = allowed.includes(this.displayTarget.value) ? this.displayTarget.value : allowed[0]

    this.displayTarget.replaceChildren(...allowed.map(value => {
      const option = document.createElement("option")
      option.value = value
      option.textContent = labels[value]
      option.selected = value === selected
      return option
    }))

    this.toggleField(this.daysTarget, metric === "completed_tasks_trend")
    this.toggleField(this.monthsTarget, metric === "sales_by_month")
    this.toggleField(this.limitTarget, ["tasks_by_project", "workload_by_assignee"].includes(metric))
  }

  toggleField(field, visible) {
    field.hidden = !visible
    const input = field.querySelector("select, input")
    if (input) input.disabled = !visible
  }
}
